import { useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button"; // 추가된 Button import

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Custom styles for the MDAlert
import MDAlertRoot from "components/MDAlert/MDAlertRoot";
import MDAlertCloseIcon from "components/MDAlert/MDAlertCloseIcon";

function MDAlert({ color, dismissible, children, onConfirm, onCancel, ...rest }) {
  const [alertStatus, setAlertStatus] = useState("mount");

  const handleAlertStatus = () => setAlertStatus("fadeOut");

  // The base template for the alert
  const alertTemplate = (mount = true) => (
    <Fade in={mount} timeout={300}>
      <MDAlertRoot
        ownerState={{ color }}
        {...rest}
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1300,
          textAlign: 'center', // 텍스트 가운데 정렬
        }}
      >
        <MDBox display="flex" mr={6} ml={6} mt={1} mb={1} flexDirection="column" alignItems="center" color="white">
          {children}
        </MDBox>
        {dismissible && (
          <MDBox display="flex" justifyContent="center" mt={2}>
          </MDBox>
        )}
      </MDAlertRoot>
    </Fade>
  );

  switch (alertStatus) {
    case "mount":
      return alertTemplate();
    case "fadeOut":
      setTimeout(() => setAlertStatus("unmount"), 400);
      return alertTemplate(false);
    default:
      return null;
  }
}

// Setting default values for the props of MDAlert
MDAlert.defaultProps = {
  color: "info",
  dismissible: false,
  onConfirm: null,
  onCancel: null,
};

// Typechecking props of the MDAlert
MDAlert.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  dismissible: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

export default MDAlert;
